import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';
import { NumberLabel } from '../../typography';
import { hextoRgba } from '../../utils/colors';

const CompareValuesWrapper = styled.div`
  display: flex;
  min-width: 180px;

  & > span {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center;
  }
`;

const ValueWrapper = styled.span`
  padding: 3px 0;
  background-color: ${(p) => hextoRgba(p.color, 0.5)};
  margin: ${(p) => (p.center ? '0 1px' : '0')};
`;

function CompareValues({ type, positive, negative, base, style }) {
  const theme = useTheme();

  return (
    <CompareValuesWrapper style={style}>
      <ValueWrapper color={theme.colors.chart6}>
        {React.isValidElement(positive) ? (
          positive
        ) : (
          <NumberLabel size="small" type={type} value={positive} />
        )}
      </ValueWrapper>
      <ValueWrapper center color={theme.colors.chart4}>
        {React.isValidElement(base) ? base : <NumberLabel size="small" type={type} value={base} />}
      </ValueWrapper>
      <ValueWrapper color={theme.colors.chart2}>
        {React.isValidElement(negative) ? (
          negative
        ) : (
          <NumberLabel size="small" type={type} value={negative} />
        )}
      </ValueWrapper>
    </CompareValuesWrapper>
  );
}

CompareValues.propTypes = {
  type: PropTypes.oneOf(['percentage', 'day', 'year', 'currency']),
  positive: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  negative: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  base: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  style: PropTypes.object,
};

export default React.memo(CompareValues);
